import "./Leftnav.scss";
import React, { useState } from "react";
import AuthFacade from "../../../facade/auth.Facade";
import { useAppSelector } from "../../../store/hooks/StoreHooks";
import {
  bottomTooltipIcons,
  topTooltipIcons,
} from "../../../constants/tooltip";
import Tooltip from "../tooltip";
import { DotsGrid, Logo } from "../../../assets/icons";
import AppsMenu from "../navigation/NavigationBar";

const LeftNav: React.FC = () => {
  const { applogout } = AuthFacade();
  const { customerEnabled, user } = useAppSelector((state) => state?.auth);
  const [showDialog, setShowDialog] = useState<boolean>(false);

  const handleLogout = () => {
    applogout();
  };

  return (
    <div className="left-nav__container">
      <div className="left-nav__logo">
        <Logo />
      </div>
      <div className="left-nav__content">
        <div className="left-nav__top">
          {customerEnabled
            ? topTooltipIcons?.customer?.map((icon) => (
              <Tooltip
                key={icon.id}
                icon={icon.icon}
                tooltipText={icon.tooltipText}
                link={icon.link}
                handleClick={() => { }}
              />
            ))
            : user?.userRole?.includes("Admin") ?
              topTooltipIcons?.admin?.map((icon) => (
                <Tooltip
                  key={icon.id}
                  icon={icon.icon}
                  tooltipText={icon.tooltipText}
                  link={icon.link}
                  handleClick={icon.handleClick}
                />
              ))
              : topTooltipIcons?.nonAdmin?.map((icon) => (
                <Tooltip
                  key={icon.id}
                  icon={icon.icon}
                  tooltipText={icon.tooltipText}
                  link={icon.link}
                  handleClick={icon.handleClick}
                />
              ))
          }
        </div>
        <div className="left-nav__bottom">
          <div className={`mb-[8px] hover:bg-darkcolor-500 rounded-[6px] shadow-none focus:outline-none ${showDialog ? "rounded-[6px] bg-darkcolor-600 tooltip-shadow" : ""}`} onClick={() => setShowDialog(true)}>
            <div className="p-[12px] flex items-center justify-center group">
              <DotsGrid />
              <div className='absolute z-999 b-[20%] left-[68px] hidden group-hover:block bg-darkcolor-400 w-auto flex justify-center items-center rounded-[8px] py-[4px] px-[8px] min-w-[50px] whitespace-nowrap'>
                <div className='absolute top-[12px] left-[-3px] origin-center rotate-45 w-0 h-0 border-l-0 border-r-[6px] border-darkcolor-400 border-b-[6px]'></div>
                <div className='text-neutral-25'>Apps launcher</div>
              </div>
            </div>
          </div>
          {customerEnabled
            ? bottomTooltipIcons?.customer?.map((icon) => (
              <Tooltip
                key={icon.id}
                icon={icon.icon}
                tooltipText={icon.tooltipText}
                link={icon.link}
                handleClick={
                  icon.tooltipText === "Logout" ? handleLogout : () => { }
                }
              />
            ))
            : bottomTooltipIcons?.admin?.map((icon) => (
              <Tooltip
                key={icon.id}
                icon={icon.icon}
                tooltipText={icon.tooltipText}
                link={icon.link}
                handleClick={
                  icon.tooltipText === "Logout" ? handleLogout : () => { }
                }
              />
            ))}
        </div>
      </div>
      {showDialog && (
        <AppsMenu
          isOpen={showDialog}
          onClose={() => setShowDialog(!showDialog)}
          isInternalUser={false}
        />
      )}
    </div>
  );
};

export default LeftNav;
